"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("../App.css");
var _actions = require("../actions");
var _reactRedux = require("react-redux");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const mapStateToProps = state => {
  return {
    apiTesterConfiguration: state.apitester
  };
};
const mapDispatchToProps = dispatch => ({
  newHeader: () => dispatch((0, _actions.newHeader)()),
  copyIdToken: () => dispatch((0, _actions.copyIdToken)()),
  handleChangeHeader: (item, e) => dispatch((0, _actions.handleChangeHeader)(item, e))
});
function Headers(props) {
  const listItems = props.apiTesterConfiguration.headers.map((item, key) => /*#__PURE__*/_react.default.createElement("div", {
    className: "row no-gutters",
    id: key,
    key: key
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "text",
    name: "headerKey",
    value: item.headerKey,
    onChange: e => props.handleChangeHeader(item, e),
    className: "form-control"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "text",
    name: "headerValue",
    value: item.headerValue,
    onChange: e => props.handleChangeHeader(item, e),
    className: "form-control"
  }))));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg colMargin"
  }, /*#__PURE__*/_react.default.createElement("h5", null, "Headers"), /*#__PURE__*/_react.default.createElement("div", null, listItems))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-6 colMargin"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: props.copyIdToken,
    className: "btn btn-secondary"
  }, "Add authorization")), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-6 colMargin"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: props.newHeader,
    className: "btn btn-secondary"
  }, "\uFF0B New header"))));
}
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Headers);
module.exports = exports.default;